
















import { defineComponent } from "vue";
import useAddToList from "@/composition/useAddToList";
import getCurrentView from "@/composition/getCurrentView";
import useMatomoEvent from "@/composition/useMatomoEvent";

export default defineComponent({
  setup() {
    const { addToList, fetching } = useAddToList();
    const onAddClick = () => {
      useMatomoEvent({
        category: `${getCurrentView()} View`,
        action: `Click "Zu geöffneter Mappe" in ${getCurrentView()}-View`,
        name: `Zu Geöffneter Mappe Collab in ${getCurrentView()}-View`
      });
    };

    return { addToList, fetching, onAddClick };
  }
});
